import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  greyMui,
  redMui,
  rydeColors,
  ScreenDepth,
} from "@ryde/theme";

export const BookingsPanelTopWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "bookings-panel-top-wrapper",
})`
  min-width: 100%;
  margin-bottom: 0;
  border-bottom: 1px solid ${greyMui._300};
  background-color: ${rydeColors.white};
  .top_grid_settings_line {
    width: 100%;
    height: 30px;
    padding-inline: 26px 15px;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 2px;
    display: flex;
    align-items: center;
  }

  .calender-view-mode-switch_highlighted {
    color: ${redMui._400};

    &.MuiSelect-root::before,
    &.MuiSelect-root::after {
      border-color: ${redMui._700};
    }
  }
`;

export const CalendarPanelWrapperStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "calendar-panel-wrapper",
})`
  width: 100%;
  min-width: 0;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  background-color: ${rydeColors.smoke};
  padding-inline-start: 20px;
  padding-inline-end: 15px;
  padding-top: 1px;
  padding-bottom: 1px;
  z-index: ${ScreenDepth.MAIN_CONTAINER};
  position: relative;
`;

export const BookingsGridPanelWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "bookings-grid-panel-wrapper",
  },
)`
  width: 100%;
  min-width: 0;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: ${rydeColors.smoke};
  padding-top: 1px;
  padding-bottom: 1px;
  z-index: ${ScreenDepth.MAIN_CONTAINER};
  position: relative;

  & [data-e2e="table-item-wrapper"],
  & .middle_scrollbar {
    min-height: 0;
    max-height: 100%;
  }
`;

export const BookingCalendarFloatingSuspense = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "bookings-calendar-floating-suspense",
  },
)`
  width: 750px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  span.loading_text {
    font-size: 16px;
    color: ${blueGreyMui._500};
  }
`;
